import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Progress,
  StatCard,
} from '@skylabs-digital/backoffice-kit';
import { Activity, Database, Files, Upload } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { AppStats } from '../../schemas/app.schema';
import { formatBytes } from './AppList';

export function StorageStatsCard({ appId, stats }: { appId: string; stats: AppStats | null }) {
  const loading = stats === null;
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0">
        <CardTitle>Storage</CardTitle>
        <Button asChild variant="outline" size="sm">
          <Link to={`/processing?app=${appId}`}>
            <Activity /> Processing queue
          </Link>
        </Button>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="grid gap-3 sm:grid-cols-3">
          <StatCard
            label="Used"
            value={formatBytes(stats?.bytesUsed)}
            icon={<Database />}
            loading={loading}
          />
          <StatCard
            label="Files"
            value={stats?.fileCount ?? '—'}
            icon={<Files />}
            loading={loading}
          />
          <StatCard
            label="Pending uploads"
            value={stats?.pendingCount ?? '—'}
            icon={<Upload />}
            tone={stats && stats.pendingCount > 0 ? 'warning' : 'neutral'}
            loading={loading}
          />
        </div>
        {stats?.quotaBytes != null ? (
          <div className="space-y-1 text-sm text-muted-foreground">
            <span>
              {stats.quotaUsedPercent ?? 0}% of {formatBytes(stats.quotaBytes)}
            </span>
            <Progress value={stats.quotaUsedPercent ?? 0} />
          </div>
        ) : stats ? (
          <div className="text-sm text-muted-foreground">No quota</div>
        ) : null}
      </CardContent>
    </Card>
  );
}
